import { render, staticRenderFns } from "./CWComment.vue?vue&type=template&id=ce6bda3c&scoped=true&"
import script from "./CWComment.vue?vue&type=script&lang=js&"
export * from "./CWComment.vue?vue&type=script&lang=js&"
import style0 from "./CWComment.vue?vue&type=style&index=0&id=ce6bda3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce6bda3c",
  null
  
)

export default component.exports